import dayjs from "dayjs";
//#region src/modules/Scheduling/shared/ShiftProgressBar/utils/getElapsedTimePercent.ts
var getElapsedTimePercent = (startTime, endTime) => {
	const shiftMinutes = dayjs(endTime).diff(startTime, "minutes");
	const elapsedMinutes = dayjs().diff(dayjs(startTime), "minutes");
	return Math.round(elapsedMinutes / 10 * 100 / (shiftMinutes / 10));
};
//#endregion
export { getElapsedTimePercent };

//# sourceMappingURL=getElapsedTimePercent.js.map